module.exports = __webpack_public_path__ + "img/logo-arcoship-BLANC.6170e935.png";